import axios from "axios"

function getConf(url) {
  return {
    baseURL: url || process.env.VUE_APP_LEXICON_URL,
  }
}

export default {
  async loadContextHelpIndex(url) {
    if (!this.contextHelpIndex) {
      const {data} = await axios.get('/assets/data/mapping/contexthelp/index.json', getConf(url))
      this.contextHelpIndex = data.context.index.reduce((acc, item) => {
        acc[item.ref] = item
        return acc
      } , {})
    }

    return this.contextHelpIndex
  },

  async loadParserIndex(url) {
    if (!this.parserIndex) {
      const {data} = await axios.get('/assets/data/mapping/parser/index.json', getConf(url))
      this.parserIndex = data
    }

    return this.parserIndex.context.index
  },

  async loadGlossar(url) {
    if (this.glossarEntries) {
      return this.glossarEntries
    }

    const glossarData = await axios.get('/assets/data/mapping/glossar/index.json', getConf(url))
    //console.log("glossar glossarData", glossarData)
    const data = glossarData.data
    //console.log("glossar data", data)
    this.glossarEntries = data.context.index.map((entry, index) => ({
      ...entry,
      index
    }))
    return this.glossarEntries
  },

  async loadTooltip(uid) {
    const {data} = await axios.get(`/assets/data/tooltip/${uid}/index.json`, getConf())
    return data.context.entry
  },

  async loadArticle(uid) {
    if(uid?.content){
      //preloaded or injected
      return uid.content
    }
    const {data} = await axios.get(`/assets/data/entry/${uid}/index.json`, getConf())
    return data.context.entry
  },

  hasContextHelp(uid) {
    return !!this.contextHelpIndex[uid.toLowerCase()]
  },

  async loadContextHelp(uid) {
    if (this.hasContextHelp(uid)) {
      uid = uid.toLowerCase()
      const {data} = await axios.get(`/assets/data/contexthelp/${uid}/index.json`, getConf())
      return data.context.entry
    }
    return null
  },

  async loadAutoRunTour(uid){
    const contextHelpConf =this.contextHelpIndex[uid.toLowerCase()]
    if(contextHelpConf?.autoRun){
      const contextHelp = await this.loadContextHelp(uid)
      const tour = contextHelp.body.find( slice => slice.type === 'tour' && slice.primary.auto_run)
      return tour
    }
    return null
  },

  /**Use this just for unit tests*/
  setParserIndex(index) {
    this.parserIndex = {
      context: {
        index
      }
    }
  },

  getParserIndex() {
    return this.parserIndex.context.index
  }
}
